export default __webpack_public_path__ + "static/media/icon-filter.b5c089cc.svg";